export default __webpack_public_path__ + "static/media/sauced_strawberry_gelato.d51e1cec.png";